import './footer.css'

function Footer() {
    return (
        <div className='footer'>
        <p><b>Exqui Real Estate.</b> <i>A home for a life time experience</i></p>
            <h3>Developed by Exquisitart Technologies</h3>
            <p><b>Email:</b>exquisitartservices555@gmail.com</p>
            <p>&copy;2022 All Rights Reserved</p>
        </div>
    )
}

export default Footer
